module.exports = __webpack_public_path__ + "media/Toxic Moral Avenger.4d8fff38.mp3";